/*
 * Copyright (c) 2024 Helvia Technologies PC <contact@helvia.io>
 */
import { useMutation } from "@tanstack/react-query";
import { queryClient } from "@/utils/queryClient";
import { cancelSubscription } from "./queryFunctions";

export const useCancelSubscription = () => {
  return useMutation({
    mutationFn: cancelSubscription,
    onSuccess: async (data, context) => {
      // Simulate a delay of 3 seconds
      await new Promise((resolve) => setTimeout(resolve, 3000));
      queryClient.invalidateQueries({
        queryKey: ["project", context.projectId],
      });
      return data;
    },
  });
};
